import {CellProps, Column, Row} from '@komune-io/g2-layout'
import {Typography} from '@mui/material'
import {TFunction} from 'i18next'
import {PlatformTableSearchFilters, PlatformPaginatedTable} from "@tracabois/template";
import {firstPage, OffsetPagination, PageQuery, PageResult} from "@tracabois/utils";
import {OwnershipType} from "../../model/OwnershipType";

interface OwnershipTypeTableProps {
  page?: PageResult<OwnershipType>
  isLoading?: boolean
  onPageQueryChange: (page: PageQuery) => void;
  onRowClicked: (row: Row<OwnershipType>) => void;
  actions: React.ReactNode
}

export const OwnershipTypeTable = (props: OwnershipTypeTableProps) => {
  const {page, isLoading, onPageQueryChange, onRowClicked, actions} = props

  const onSearch = (search?: string) => {
    onPageQueryChange({
      pagination: page?.pagination || firstPage,
      search: search
    })
  }
  const filter = (
    <PlatformTableSearchFilters actions={actions} onSubmit={(props) => onSearch(props.search)}/>
  )
  const onPaginationChange = (pagination: OffsetPagination) => {
    onPageQueryChange({
      pagination: pagination,
      search: page?.search
    })
  }
  return (
    <PlatformPaginatedTable<OwnershipType>
      page={page}
      columnsDefinition={getColumns}
      isLoading={isLoading}
      actions={filter}
      onPageChange={onPaginationChange}
      onRowClicked={onRowClicked}
      noElevation
    />
  )
}


const getColumns = (t: TFunction): Column<OwnershipType>[] => ([{
  Header: `${t("ownershipType.name", "Libéllé")}`,
  // @ts-ignore
  Cell: ({row}: CellProps<OwnershipType>) => (
    <Typography variant="body2"
    >{row.original.name}</Typography>
  )
}])
